import { ValidPosition } from '@bakerweb/models';

export function computeMaturingAndCalled(position: ValidPosition, selectedAsOfDateFormatted: string) {
  const { disposedDate, disposedTransCode } = position;

  const disposedDateParsed = new Date(disposedDate);

  const codes = ['M', 'CC'];

  const dateRangeStart = new Date(selectedAsOfDateFormatted);
  // 45 days from dateRangeStart
  const dateRangeEnd = new Date(dateRangeStart.getFullYear(), dateRangeStart.getMonth(), dateRangeStart.getDate() + 45);

  return (
    disposedDateParsed >= dateRangeStart && disposedDateParsed <= dateRangeEnd && codes.includes(disposedTransCode)
  );
}
